import { useState, useMemo } from "react";
import { useParams } from "react-router-dom";
import AccountStatus from "./JumboPayPages/AccountStatus.js";
import ReceivedPayments from "./JumboPayPages/ReceivedPayments.js";
import SentPayments from "./JumboPayPages/SentPayments.js";
import Payouts from "./JumboPayPages/Payouts.js";
import JumboPaySettings from "./JumboPayPages/JumboPaySettings.js";
import apiRequest from "../../../../utils/ApiRequest/apiRequest.js";
import { useUser } from "contexts/userContext/userContext.js";

const JumboPay = () => {
  const [userFullDetails, setUserFullDetails] = useState(null);
  const params = useParams();
  const { getUserData } = useUser();
  const userData = getUserData();
  const renderPage = () => {
    switch (params.profilePage) {
      case "":
      case "account-status":
        return <AccountStatus userData={userData} />;
      case "received-payments":
        return <ReceivedPayments userData={userData} />;
      case "sent-payments":
        return <SentPayments userData={userData} />;
      case "payouts":
        return <Payouts userData={userData} />;
      case "settings":
        return (
          <JumboPaySettings
            userData={userData}
            userFullDetails={userFullDetails}
          />
        );
      default:
        return <AccountStatus userData={userData} />;
    }
  };

  const getUserByBearer = async () => {
    const response = await apiRequest("Users", "GetUserByBearer");
    if (response.status === "success") {
      if (response.data) {
        setUserFullDetails(response.data);
      }
    }
  };
  useMemo(() => {
    if (userData) {
      getUserByBearer();
    }
  }, []);

  return (
    <div className="user-jumbopay-container">
      {userData && userFullDetails && renderPage()}
    </div>
  );
};
export default JumboPay;
